// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('budget.budgets', {
        url: '',
        templateUrl: 'main/budget/budgets/budgets.tpl.html',
        controller: 'BudgetsController as vm'
    });
}

// @ngInject
function BudgetsController($rootScope, $state, $translate, loadSpinnerService, BudgetsApiService) {
    var vm = this;

    vm.budgets = [];
    vm.currentPage = 1;
    vm.itemsPerPage = 15;
    vm.totalItems= 0;
    vm.filter = '';

    vm.loadSpinnerService = loadSpinnerService;
    vm.BudgetsApiService = BudgetsApiService;
    vm.onBudgetImported = onBudgetImported;

    function onBudgetImported(budgets) {
        BudgetsApiService.importBudgets({budgets:budgets}).then(function (response) {
            loadBudgets();
        })
        .catch(function (error) {
            console.error(error);
        });
    }

    function loadBudgets() {
        vm.loadSpinnerService.start('mainSpinner');
        vm.BudgetsApiService.getSalesBudgets(vm.currentPage, vm.filter, vm.itemsPerPage).then(function (response) {
            vm.budgets = response.results;
            vm.totalItems = response.total;
        }).finally(function() {
            vm.loadSpinnerService.stop('mainSpinner', {force: true});
        });
    }

    vm.loadBudgets = loadBudgets;
    loadBudgets();
}


angular
    .module('budget.budgets', ['budgets.api'])
    .config(stateConfig)
    .controller('BudgetsController', BudgetsController);
